import { useIsThinkingDots } from "@/hooks/useIsThinkingDots";

export function TypingIndicator({ showText = true }: { showText?: boolean }) {
  const dots = useIsThinkingDots();

  return (
    <div className="flex items-center rounded-lg max-w-xs">
      <div className="flex space-x-1">
        <div className="w-1 h-1 bg-muted-foreground rounded-full animate-bounce delay-0 duration-700" />
        <div className="w-1 h-1 bg-muted-foreground rounded-full animate-bounce delay-150 duration-700" />
        <div className="w-1 h-1 bg-muted-foreground rounded-full animate-bounce delay-300 duration-700" />
      </div>
      {showText && (
        <div className="ml-2 text-muted-foreground text-sm font-medium">
          Thinking{dots}
        </div>
      )}
    </div>
  );
}
